import { useRecoilState } from 'recoil';
import { authAtom, alertAtom } from '_state';
import { useFetchWrapper } from '_helpers';

export { useAuthWrapper };

function useAuthWrapper() {
    const [auth, setAuth] = useRecoilState(authAtom);
    const [, setAlert] = useRecoilState(alertAtom);
    const fetchWrapper = useFetchWrapper();

    // The login identifier is the email; the server reads it from the `username` field.
    async function login({ email, password }) {
        const body = new URLSearchParams();
        body.append('username', email);
        body.append('password', password);
        const response = await fetchWrapper.post('/api/auth/login', 'application/x-www-form-urlencoded', body);
        const rawjson = await response.json();
        if (rawjson.status === 'Logged In Success') {
            // Load the profile + capabilities BEFORE flipping the auth flag. Otherwise the app
            // renders the authed view before capabilities exist → empty nav + a redirect loop
            // that lands on a blank page until a full reload.
            const me = await loadUser();
            if (me.status === 'Success') {
                setAuth('authenticated');
            } else {
                setAlert({ message: 'Thất bại', description: 'Không tải được thông tin tài khoản' });
            }
        } else {
            setAlert({ message: 'Thất bại', description: 'Sai email hoặc mật khẩu' });
        }
        return rawjson;
    }

    async function logout() {
        try { await fetchWrapper.post('/api/auth/logout', null, null); } catch (_) {}
        setAuth('');
        setAlert({ message: null, description: null });
        localStorage.removeItem('mh_userData');
    }

    // Fetch the profile + authoritative capability map from /api/auth/me and cache it.
    async function loadUser() {
        const res = await fetchWrapper.get('/api/auth/me', null, null);
        const json = await res.json();
        if (json.status === 'Success') {
            const u = json.message;
            localStorage.setItem('mh_userData', JSON.stringify({
                _id: u._id, name: u.name, role: u.role, email: u.email, capabilities: u.capabilities,
            }));
        }
        return json;
    }

    function getUserData() {
        try { return JSON.parse(localStorage.getItem('mh_userData') || '{}'); } catch (_) { return {}; }
    }

    return { login, logout, loadUser, getUserData, tokenValue: auth };
}
